import * as React from "react";

import { useSelector } from 'react-redux';
import { navigateTop } from '../routing/router-utils';
import RegFlowHeader from "../registration/RegFlowHeader";
import GreenPageBody from '../layout/GreenPageBody';
import AddressSearch from './AddressSearch';

import '../registration/MaterialUI.module.css';
import styles from '../registration/Registration.module.css';
import localStyles from './Address.module.css';

/**
 * Provide typeahead for address lookup, store address in redux
 * for use in registration 
 */
const Register = () => {
   
  const returnTo = useSelector(state => state.return_to_path);
 
  return (
    <div className={styles.formOnlyPage}>
      <GreenPageBody />
      {/* 
        * This is the first page of the reg flow so the 'backLink'
        * returns the user to the page they entered from (checkout etc.) 
        */}
      <RegFlowHeader backLink={returnTo} pageTitle="Sign Up" />
      <div className={localStyles.registerForm}>
        <div className={styles.formHeader}>
          Sign Up for Pickup/Delivery with&nbsp;Zip&nbsp;Run
          {/* TODO LAUNCH: disabled until launch
          <div className={styles.headerLink} onClick={() => navigateTop("/signIn") }>
            Already have an account? <b>Log In</b>
          </div>
          */}
        </div>
          <div className={localStyles.inputWrap}>
            <AddressSearch onComplete={() => navigateTop('/signUp/signUp?backLink=address')} />
          </div>
      </div>
    </div>
  );
}

export default Register;